export const FRONT_LOAD = 'FrontLoad';
export const CART = 'Cart';

export const SERVICE_TYPES = {
  [FRONT_LOAD]: { name: 'Front Load', value: FRONT_LOAD },
  [CART]: { name: 'Cart', value: CART },
};
